import {Component} from '@angular/core';
import {SearchForm} from '../../../sdk/component/search/searchForm';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../sdk/service/authentication.service';
import {SearchService} from '../../../sdk/component/search/search.service';
import {NotificationRequest, UserInvitation, UsersSortField, WebUserInvitationService} from 'web-angular-client';
import {ConfirmationService} from '../../../sdk/service/confirmation.service';
import {AlertService} from '../../../sdk/service/alert.service';
import {ROUTES} from '../../../app.routes';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {LayoutService} from '../../layout/layout.service';
import {SubscriptionService} from '../../../sdk/service/subscription.service';
import {EnvironmentService} from '../../../sdk/service/environment.service';
import NotificationTypeEnum = NotificationRequest.NotificationTypeEnum;

@Component({
    selector: 'app-user-invitation-list',
    templateUrl: './user-invitation-list.component.html',
    styleUrls: ['./user-invitation-list.component.scss'],
    standalone: false
})
export class UserInvitationListComponent extends SearchForm
{

    constructor(
        protected router: Router,
        protected authenticationService: AuthenticationService,
        protected environmentService: EnvironmentService,
        protected userInvitationService: WebUserInvitationService,
        protected searchService: SearchService,
        private layoutService: LayoutService,
        private subscriptionService: SubscriptionService,
        protected confirmationService: ConfirmationService,
        protected alertService: AlertService,
        protected ngxLoader: NgxUiLoaderService)
    {
        super(authenticationService, userInvitationService, searchService, environmentService);
    }

    get isSubscriptionValid(): boolean
    {
        return this.subscriptionService.isSubscriptionValid;
    }

    get content(): UserInvitation[]
    {
        return this.results?.content;
    }

    get getTooltipText(): string
    {
        if (this.isGuestAdminUser())
        {
            return 'Guest accounts cannot create new users.';
        }
        else if (!this.isSubscriptionValid)
        {
            return 'Please pay your subscription fee before attempting to create new users.';
        }
        return '';
    }

    ngOnInit(): void
    {
        super.ngOnInit();
        this.router.routeReuseStrategy.shouldReuseRoute = function()
        {
            return false;
        };
        this.layoutService.loadPrepaidServicesStatusInfo();
    }

    create()
    {
        if (this.isGuestAdminUser())
        {
            this.alertService.error('Guest accounts cannot perform this action.', false);
            return;
        }

        this.router.navigate([this.routes.SECURE.USER.CREATE.path]).then();
    }

    view(userInvite: UserInvitation)
    {
        // intentionally blank
    }

    getDefaultSortField(): string
    {
        // UsersSortField.ID is used by default as no sorting has been applied to this component
        return UsersSortField.ID;
    }

    deleteUserInvitation(userInvitation: UserInvitation)
    {
        this.confirmationService.confirm('Delete Invitation', `Are you sure you wish to delete user 
    invitation for ${userInvitation.email} ?`)
            .then((confirmed) =>
            {
                if (confirmed)
                {
                    this.ngxLoader.start();
                    this.userInvitationService.deleteUserInvitation(userInvitation.email).subscribe({
                        next: () =>
                        {
                            this.ngxLoader.stop();
                            this.alertService.success(
                                `User invitation for ${userInvitation.email} has been successfully deleted.`,
                                true);
                            this.router.navigate([ROUTES.SECURE.USER.INVITATION.LIST.path], {}).then();
                        },
                        error: (error) =>
                        {
                            this.ngxLoader.stop();
                            this.alertService.error(error);
                        }
                    });
                }
            })
            .catch(() =>
            {
            });
    }

    resend(userInvitation: UserInvitation)
    {
        this.confirmationService.confirm('Resend Invitation', `Are you sure you wish to resend user 
    invitation to ${userInvitation.email} ?`)
            .then((confirmed) =>
            {
                if (confirmed)
                {
                    const notificationRequest: NotificationRequest = {
                        email: userInvitation.email,
                        notificationType: NotificationTypeEnum.EMAIL,
                        initiatorType: 'MERCHANT'
                    };

                    this.ngxLoader.start();
                    this.userInvitationService.sendUserInvitationNotification(notificationRequest)
                        .subscribe({
                            next: (notificationResponse) =>
                            {
                                this.ngxLoader.stop();
                                this.alertService.success(notificationResponse.responseMessage);
                            }, error: (error) =>
                            {
                                this.ngxLoader.stop();
                                this.alertService.error(error);
                            }
                        });
                }
            })
            .catch((reason) =>
            {
                this.debugOutput(reason);
            });
    }
}